var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragonfly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 57,
    viewBox: "0 0 148 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.2127 3.96764C78.2127 6.1589 76.4334 7.93527 74.2385 7.93527C72.0435 7.93527 70.2642 6.1589 70.2642 3.96764C70.2642 1.77637 72.0435 0 74.2385 0C76.4334 0 78.2127 1.77637 78.2127 3.96764Z",
    fill: "#CCE8E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7499 21.5939C77.1421 17.6763 79.8118 11.2522 75.894 9.94725C75.6612 9.86971 75.4088 9.96254 75.2573 10.1553L74.7338 10.8211C74.4792 11.145 73.988 11.145 73.7334 10.8211L73.2099 10.1553C73.0584 9.96254 72.8061 9.86971 72.5733 9.94725C68.6554 11.2522 71.3251 17.6763 73.7173 21.5939C73.9552 21.9834 74.512 21.9834 74.7499 21.5939Z",
    fill: "#CCE8E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1432 19.9546C76.7904 21.2101 75.6577 24.758 74.1252 24.758C72.6017 24.758 71.5185 21.2515 71.1751 19.9769C71.1559 19.9054 71.0479 19.9178 71.047 19.9918C71.0161 22.6974 71.5379 27.7665 72.3765 29.2018C73.4879 31.1039 70.0008 57.8602 74.1097 56.9787C74.1191 56.9767 74.1313 56.9767 74.1407 56.9787C78.2496 57.8602 74.7625 31.1039 75.8738 29.2018C76.7147 27.7627 77.2973 22.6708 77.2701 19.9706C77.2693 19.897 77.1631 19.8838 77.1432 19.9546Z",
    fill: "#CCE8E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.099 4.60246C98.9422 10.5698 86.1611 12.379 80.9151 12.5377C90.4003 18.7801 110.96 26.0277 121.293 18.0924C132.57 9.4327 143.072 5.9779 148 6.50692C138.515 3.38571 117.255 -1.36487 108.099 4.60246Z",
    fill: "#CCE8E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7913 27.291C89.7515 25.8145 82.9631 20.7206 80.4488 18.3582C81.9524 25.6669 88.1394 38.5863 96.6434 39.6937C105.924 40.9022 112.419 44.1725 114.465 46.7071C111.507 40.8503 103.831 28.7676 96.7913 27.291Z",
    fill: "#CCE8E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9012 4.76077C49.0578 10.7281 61.8389 12.5373 67.0849 12.696C57.5997 18.9385 37.0397 26.186 26.7068 18.2507C15.4304 9.59102 4.92803 6.13622 0 6.66524C9.48514 3.54403 30.7446 -1.20655 39.9012 4.76077Z",
    fill: "#CCE8E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2087 27.426C58.2485 25.9495 65.0369 20.8556 67.5512 18.4932C66.0476 25.8019 59.8606 38.7213 51.3566 39.8287C42.0762 41.0372 35.581 44.3074 33.5351 46.8421C36.493 40.9853 44.1688 28.9025 51.2087 27.426Z",
    fill: "#CCE8E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragonfly);
export default __webpack_public_path__ + "static/media/dragonfly.df1b3e8c8ff2688e8a33495aa724f697.svg";
export { ForwardRef as ReactComponent };